/**
 * Route for `auto-alert-publisher-manager-email`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutoAlertPublisherManagerEmailPage } from "../features/auto-alert-publisher-manager-email/AutoAlertPublisherManagerEmailPage";

export const autoAlertPublisherManagerEmailRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/auto-alert-publisher-manager-email",
	component: AutoAlertPublisherManagerEmailPage,
});

export default autoAlertPublisherManagerEmailRoute;
